import React, {useState} from "react"

import {FieldEditableMode, FieldEditableProps} from "../../../../../proto/render/editable"
import {FieldViewSize} from "../../../../../const"
import EditableInput from "../../../../../generic/string/render/inline-editable/input-component"

const debug = false
// const debug = "FieldProjectName_Editable"

export default function FieldProjectName_Editable(props:FieldEditableProps) {


    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (mode === FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode !== FieldEditableMode.EDITING) {
            setMode(FieldEditableMode.EDITING)
            props.onFocus && props.onFocus()
        }
    }

    const onChange = (newValue:any) => {
        props.onChange && props.onChange(newValue)

        setMode(FieldEditableMode.VIEW)
        props.onBlur && props.onBlur()
    }

    const value         = props.field.getViewValue(props.model)
    const displayValue  = props.field.getDisplayValue(value)

    const classes = Classes("ui5-field-editable", props.className, {
        "ui5-txt-default"               : props.size === FieldViewSize.DEFAULT,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "ui5-txt-less-important-small"  : props.size === FieldViewSize.SMALL,
        "size-small"                    : props.size === FieldViewSize.SMALL,
    })

    const renderEditing = () => {
        return (
            <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-100-percent h-36" // p-l-10 p-r-10
                           inputClassName   = "ui5-txt-default"
                           value            = {value}
                           focusOnMount     = {true}
                           placeholder      = {props.field.placeholder}
                           onChange         = {onChange}
                           onFocus          = {props.onFocus}
                           onBlur           = {props.onBlur}/>
        )
    }


    const renderHovered = () => {
        const hoveredClasses = Classes(classes, "is-hovered")

        return (
            <div className      = {hoveredClasses}
                 onMouseLeave   = {onMouseLeave}
                 onClick        = {onClick}>
                <div className="txt-truncate">{displayValue}</div>
            </div>
        )
    }

    const renderView = () => {
        return (
            <div className      = {classes}
                 onMouseEnter   = {onMouseEnter}
                 onClick        = {onClick}>
                <div className="max-w-100-percent txt-truncate">{displayValue}</div>
            </div>
        )
    }

    switch (mode) {
        case FieldEditableMode.EDITING  :
            return renderEditing()

        case FieldEditableMode.HOVERED  :
            return renderHovered()

        case FieldEditableMode.VIEW     :
        default                         :
            return renderView()
    }
}
